import React from 'react';
import IntakeStartScreen from 'components/common/intakeStartScreen';
import ConsentFormApp from 'components/consentForm';

function ConsentFormStartScreen() {
  return (
    <IntakeStartScreen
      currentStep="forms"
      metaTitle="Acknowledge & Sign Form"
      fullWidthContent
    >
      <ConsentFormApp />
    </IntakeStartScreen>
  );
}

export default ConsentFormStartScreen;
